import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onChange", "onValidChange", "children", "className", "getValidators", "domNodeRef", "id", "values"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { Form, FormSpy } from 'react-final-form';
import { ignoreState } from '@beef/react';
import { composeFormValidator } from '@beef/utils/validators';
import { filter, shallowEqual } from '@beef/utils';
import { setIn } from 'final-form';
import { validatorExist } from "./utils";
// ToDo: Разбить на несколько более меленьких компонентов
// ToDo: Написать тесты
// ToDo: Добавить возможность определения валидации вне компонента с помощью оберток
export var FinalForm = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FinalForm, _React$PureComponent);
  var _super = _createSuper(FinalForm);
  function FinalForm(props) {
    var _this;
    _classCallCheck(this, FinalForm);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "memory", {
      valid: null
    });
    _defineProperty(_assertThisInitialized(_this), "timer", void 0);
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (_ref) {
      var values = _ref.values;
      var onChange = _this.props.onChange;
      var stateValues = _this.state.values;
      if (!shallowEqual(values, stateValues)) {
        _this.setState({
          values: values
        }, function () {
          return onChange === null || onChange === void 0 ? void 0 : onChange(values);
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleValidChange", function (_ref2) {
      var hasValidationErrors = _ref2.hasValidationErrors;
      var onValidChange = _this.props.onValidChange;
      var valid = !hasValidationErrors;
      if (valid !== _this.memory.valid) {
        clearTimeout(_this.timer);
        _this.timer = setTimeout(function () {
          return onValidChange === null || onValidChange === void 0 ? void 0 : onValidChange(valid);
        });
      }
      _this.memory.valid = valid;
    });
    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (values) {
      var onSubmit = _this.props.onSubmit;
      if (onSubmit) {
        return Promise.resolve(onSubmit(values)).then(function () {
          return null;
        }).catch(function (errors) {
          return _this.handleErrors(errors);
        });
      }
      return undefined;
    });
    /**
     * Separate validation Errors from global errors
     * @returns {[{object validationErrors}, {array globalErrors}]}
     */
    _defineProperty(_assertThisInitialized(_this), "separateValidationErrors", function (errors) {
      var getValidators = _this.props.getValidators;
      var values = _this.state.values;

      // values передавались в старой версии, возможно где-то в legacy коде используется
      var validators = (getValidators === null || getValidators === void 0 ? void 0 : getValidators(values)) || {};
      var validationErrors = filter(errors, function (_, key) {
        return validatorExist(validators, key);
      });
      var globalErrors = filter(errors, function (_, key) {
        return !validatorExist(validators, key);
      });
      return [validationErrors, Object.values(globalErrors).flat()];
    });
    /**
     * There are two types of errors:
     * - validation errors - that are listed in getValidators are returned under field name and passed into payFormFields
     * - all the other errors, passed into `errors` field and thrown by FinalForm onError callback
     */
    _defineProperty(_assertThisInitialized(_this), "handleErrors", function (errors) {
      var onError = _this.props.onError;
      if (_typeof(errors) === 'object' && errors !== null) {
        var _this$separateValidat = _this.separateValidationErrors(errors),
          _this$separateValidat2 = _slicedToArray(_this$separateValidat, 2),
          fieldValidationErrors = _this$separateValidat2[0],
          otherGlobalErrors = _this$separateValidat2[1];
        if (onError && otherGlobalErrors.length) {
          onError(otherGlobalErrors);
        }
        return _objectSpread(_objectSpread({}, fieldValidationErrors), {}, {
          errors: otherGlobalErrors
        });
      }
      return null;
    });
    _defineProperty(_assertThisInitialized(_this), "runSchemaValidation", function (schema) {
      return function (values) {
        try {
          // при асинхронном подходе бесконечный ререндер поэтому используется validateSync
          schema.validateSync(values, {
            abortEarly: false
          });
        } catch (err) {
          var _typedError$inner;
          var typedError = err;
          var _errors = typedError === null || typedError === void 0 ? void 0 : (_typedError$inner = typedError.inner) === null || _typedError$inner === void 0 ? void 0 : _typedError$inner.reduce(function (formError, innerError) {
            return setIn(formError, innerError.path, innerError.message);
          }, {});
          if (JSON.stringify(_this.state.validationErrors) !== JSON.stringify(_errors)) {
            _this.setState(function (state) {
              return _objectSpread(_objectSpread({}, state), {}, {
                validationErrors: _errors
              });
            });
          }
          return _this.state.validationErrors;
        }
        return {};
      };
    });
    _defineProperty(_assertThisInitialized(_this), "validate", function () {
      var _this$props = _this.props,
        getValidators = _this$props.getValidators,
        validationSchema = _this$props.validationSchema;
      if (getValidators) {
        return composeFormValidator(getValidators);
      }
      if (validationSchema) {
        return _this.runSchemaValidation(validationSchema);
      }
      return undefined;
    });
    _this.state = {
      values: props.values || {},
      isInitialValueChanged: false,
      validationErrors: {}
    };
    return _this;
  }

  /**
   * `gdsfp` and `isInitialValueChanged` are required
   *  in order to skip internal changes backfiring into the system
   *  and only react to external changes
   */
  _createClass(FinalForm, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        onValidChange = _this$props2.onValidChange,
        children = _this$props2.children,
        className = _this$props2.className,
        getValidators = _this$props2.getValidators,
        domNodeRef = _this$props2.domNodeRef,
        id = _this$props2.id,
        _omitValues = _this$props2.values,
        otherFormProps = _objectWithoutProperties(_this$props2, _excluded);
      var _this$state = this.state,
        values = _this$state.values,
        isInitialValueChanged = _this$state.isInitialValueChanged;
      return /*#__PURE__*/React.createElement(Form, _extends({}, otherFormProps, {
        initialValues: values,
        initialValuesEqual: function initialValuesEqual() {
          return !isInitialValueChanged;
        },
        onSubmit: this.handleSubmit,
        render: function render(formApi) {
          return /*#__PURE__*/React.createElement("form", {
            className: className,
            id: id,
            noValidate: true,
            onSubmit: formApi.handleSubmit,
            ref: domNodeRef
          }, onChange && /*#__PURE__*/React.createElement(FormSpy, {
            onChange: _this2.handleChange,
            subscription: {
              values: true
            }
          }), onValidChange && /*#__PURE__*/React.createElement(FormSpy, {
            onChange: _this2.handleValidChange,
            subscription: {
              hasValidationErrors: true
            }
          }), typeof children === 'function' ? children(formApi) : children);
        },
        validate: this.validate(),
        "data-t-id": "components-FinalForm"
      }));
    }
  }]);
  return FinalForm;
}(React.PureComponent);
_defineProperty(FinalForm, "getDerivedStateFromProps", ignoreState(function (nextProps, prevState) {
  if (!nextProps.values || !prevState.values) {
    return undefined;
  }
  if (!shallowEqual(nextProps.values, prevState.values)) {
    return {
      values: nextProps.values,
      isInitialValueChanged: true
    };
  }
  return {
    isInitialValueChanged: false
  };
}));